import React, {Fragment, FunctionComponent} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import {bindActionCreators} from "@reduxjs/toolkit";
import {setRentalCarSelection} from "@App/state/action-creators";
import {actionCreators} from "@App/state";

type RentalCarSelectProps = {
}

export const RentalCarSelect: FunctionComponent<RentalCarSelectProps> = (props: RentalCarSelectProps) => {


    const {t} = useTranslation()

    const dispatch = useDispatch();
    const {setRentalCarSelection} = bindActionCreators(actionCreators, dispatch)


    const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        setRentalCarSelection(e.target.value);
    }

    return (
        <Fragment>
            <div className={'py-2 px-3 my-2'}>
                <label>
                    <input type="radio" name="rentalCarOptions" value="A" onChange={handleChange}/> {t('rentalCarOptions.a')}
                </label><br/>
                <label>
                    <input type="radio" name="rentalCarOptions" value="B" onChange={handleChange}/> {t('rentalCarOptions.b')}
                </label><br/>
                <label>
                    <input type="radio" name="rentalCarOptions" value="I" onChange={handleChange}/> {t('rentalCarOptions.i')}
                </label>
            </div>
        </Fragment>
    )
}
